import axios from 'axios';
import { CreatePaymentDto } from '../../types/payment';

export const paymentApi = {
	async createPayment(payment: CreatePaymentDto) {
		const { data } = await axios.post(`/payment/adhoc-payments`, payment);
		return data;
	},
};
